<template>
  <el-container v-loading="loading" id="top" style="height:969px;">
    <el-header>
      <HeaderView :userName="viewUserName" @calcHeaderSpace="calcHeaderSpace" />
    </el-header>
    <el-container>
      <el-container id="submenu" style="height:100%;overflow:auto;">
        <el-aside>
          <MenuView :cowMenuRadio="cow_menu_radio" :isAdmin="isAdmin" :userType="userType" :farmerId="farmer_id" />
        </el-aside>
      </el-container>
      <el-container id="sub" style="height:880px;overflow:auto;borderLeft:1px solid #C3C2C1;">
        <el-main style="height:760px;">
          <!-- 餌やり時間 -->
          <el-row class="font_18" style="padding-top:22px;height:74px;">牛に餌やりをする時間を設定できます</el-row>
          <el-table :data="tableData" :default-sort="{ prop: 'lastestruson', order: 'descending' }" stripe
            style="min-width:315px;">
            <el-table-column label="" :width="headerWidth" />
            <el-table-column label="餌やり時間">
              <template #default="scope">
                <el-button color="#EEEEEC" class="button-style-feedtime" type="primary"
                  @click="dialog_open(scope.$index)">{{ scope.row.feed_time }}</el-button>
                <el-button text @click="click_del_feed_time(scope.$index)" style="margin-left:80%;">
                  <el-icon style="color: #383838; padding-right: 1em;">
                    <IconTrash />
                  </el-icon>
                </el-button>
              </template>
            </el-table-column>
          </el-table>
          <el-row :gutter="20" style="justify-content:left;padding-top:0em;padding-left:96px;width:auto;">
            <el-button color="#EEEEEC" text size="large" style="color:#383838;margin-top:23px;" type="primary"
              @click="add_dialog_open()">
              <el-icon style="color: #383838; padding-right: 1em;">
                <IconPlusCircle />
              </el-icon>餌やり時間を追加
            </el-button>
          </el-row>
        </el-main>
      </el-container>
    </el-container>
  </el-container>
  <!-- 餌やり時刻設定 -->
  <el-dialog v-model="dialogVisible" title="餌やり時間設定" width="600px" style="z-index: 1800;">
    <el-row></el-row>
    <p v-if="message" style="color: #F56C6C;">{{ message }}</p>
    <el-row>
      <el-col :span="12">
        <span>開始時間</span>
      </el-col>
      <el-col :span="12">
        <span>終了時間</span>
      </el-col>
    </el-row>
    <el-row>
      <el-col :span="12">
        <el-time-picker v-model="start_time" format="HH:mm" placeholder="" :clearable="false"
          @change="check_feed_time()" />
      </el-col>
      <el-col :span="12">
        <el-time-picker v-model="end_time" format="HH:mm" placeholder="" :clearable="false" @change="check_feed_time()" />
      </el-col>
    </el-row>
    <template #footer>
      <el-row style="justify-content:center;overflow:auto;">
        <el-button round class="button-style-feedtime-dialog" style="background: #FFFFFF;"
          @click="this.dialogVisible = false">キャンセル</el-button>
        <el-button round class="button-style-feedtime-dialog" style="background: #ffdf5e;"
          :disabled="message !== '' || loading" @click="update_feed_time()">{{ button_caption }}</el-button>
      </el-row>
    </template>
  </el-dialog>
</template>

<script>
import HeaderView from '../components/HeaderView';
import MenuView from '../components/MenuView';
import dayjs from 'dayjs';
import 'dayjs/locale/ja';
import timezone from 'dayjs/plugin/timezone';
import utc from 'dayjs/plugin/utc';
import { getCurrentUser, signout } from "./js/cognito";
import AWSAPI from './js/aws-api';
import { ElMessage } from 'element-plus';
import ConstParam from './js/const';
import { shallowRef } from 'vue';
import * as icons from '../components/icons/modules'

// ロケール設定・タイムゾーン設定
dayjs.locale('ja');
dayjs.extend(utc);
dayjs.extend(timezone);
dayjs.tz.setDefault('Asia/Tokyo');

export default {
  name: 'FoodTimeSettingView',
  components: {
    HeaderView,
    MenuView
  },
  created() {
    this.$store.commit('setCowMenuSelect', '> 餌やり時間');
  },
  mounted() {
    this.restore_param();
    this.get_current_user();
    this.hoverCssDelete();
  },
  beforeUnmount() {
    this.hoverCssInsert();
  },
  data() {
    return {
      userType: ConstParam.disable_user_kind,
      headerWidth: "96px",
      IconPlusCircle: shallowRef(icons.IconPlusCircle),
      IconTrash: shallowRef(icons.IconTrash),
      pregnancy_term: ConstParam.pregnancy_term,
      saveStyle: [],
      farmer_env: false,
      save_index: 0,
      button_caption: '追加',
      start_time: "",
      end_time: "",
      message: "",
      dialogVisible: false,
      amnion: "ON",
      amnion_time: 5,
      calf_leg: "ON",
      calf_leg_time: 5,
      tail_up: "ON",
      tail_up_time: 5,
      move_length: "ON",
      move_length_time: 5,
      kicking: "ON",
      kicking_time: 5,
      preyon: "ON",
      preyon_time: 5,
      posture: "ON",
      posture_time: 5,
      select_times: ConstParam.select_times,
      tableData: [
        {
          start: "",
          end: ""
        }
      ],
      feeding_times: [],
      bulls: [],
      tableBulls: [],
      eggs: [],
      tableEggs: [],
      // ===== 以降固定 ====
      isAdmin: false,
      cow_menu_radio: "",
      loading: true,
      userData: {},
      farmer_id: "",
      viewUserName: "",
      viewFarmerName: "",
      logOut: false
      // ==================
    }
  },
  methods: {
    getErrorMessage(res) {
      if (
        'message' in res &&
        'response' in res.message &&
        'data' in res.message.response &&
        'message' in res.message.response.data
      ) {
        return res.message.response.data.message
      } else {
        return ""
      }
    },
    calcHeaderSpace(spacesize) {
      this.headerWidth = spacesize;
    },
    hoverCssDelete() {
      this.saveStyle = [];
      for (var si in document.styleSheets) {
        var styleSheet = document.styleSheets[si];
        if (!styleSheet.cssRules) continue;
        for (var ri = styleSheet.cssRules.length - 1; ri >= 0; ri--) {
          if (!styleSheet.cssRules[ri].selectorText) continue;

          if (styleSheet.cssRules[ri].selectorText.match(':hover')) {
            if (styleSheet.cssRules[ri].selectorText.indexOf('.el-table') != -1) {
              let tempStyle = styleSheet.cssRules[ri];
              this.saveStyle.push(tempStyle['cssText']);
              styleSheet.deleteRule(ri);
            }
          }
        }
      }
    },
    hoverCssInsert() {
      for (let i = 0; i < this.saveStyle.length; i++) {
        document.styleSheets.item(0).insertRule(this.saveStyle[i]);
      }
    },
    formatDate(date, format) {
      format = format.replace(/yyyy/g, date.getFullYear());
      format = format.replace(/MM/g, ('0' + (date.getMonth() + 1)).slice(-2));
      format = format.replace(/dd/g, ('0' + date.getDate()).slice(-2));
      format = format.replace(/HH/g, ('0' + date.getHours()).slice(-2));
      format = format.replace(/mm/g, ('0' + date.getMinutes()).slice(-2));
      format = format.replace(/ss/g, ('0' + date.getSeconds()).slice(-2));
      format = format.replace(/SSS/g, ('00' + date.getMilliseconds()).slice(-3));
      return format;
    },
    check_feed_time() {
      // 入力内容チェック
      this.message = "";
      if (!this.start_time) {
        this.message = "開始時間は必須項目です。";
      } else if (!this.end_time) {
        this.message = "終了時間は必須項目です。";
      }
    },
    dialog_open(id) {
      this.button_caption = '更新';
      this.save_index = id;
      this.start_time = new Date("2022/01/01 " + this.tableData[id]['start']);
      this.end_time = new Date("2022/01/01 " + this.tableData[id]['end']);
      this.check_feed_time();
      this.dialogVisible = true;
    },
    add_dialog_open() {
      this.button_caption = '追加';
      this.save_index = -1;
      this.start_time = new Date("2022/01/01 00:00:00");
      this.end_time = new Date("2022/01/01 00:00:00");
      this.dialogVisible = true;
    },
    add_feed_time: async function () {
      // WebAPI呼び出し.
      let add_time = this.formatDate(this.start_time, 'HH:mm') + "/" + this.formatDate(this.end_time, 'HH:mm');
      await AWSAPI.updateFarmerFeedingTimes(this.farmer_id, add_time, "")
        .then((res) => {
          if (this.checkAnswer(res, false)) {
            this.viewMessage("餌やり時間を追加しました。", "success");
            this.dialogVisible = false;
          }
          this.get_current_user();
        });
    },
    update_feed_time: async function () {
      this.loading = true;
      if (this.save_index == -1) {
        // 新規追加
        this.add_feed_time();
      } else {
        // 既存更新
        if (!(this.formatDate(this.start_time, 'HH:mm') === this.tableData[this.save_index]['start'] &&
          this.formatDate(this.end_time, 'HH:mm') === this.tableData[this.save_index]['end'])) {
          let add_time = this.formatDate(this.start_time, 'HH:mm') + "/" + this.formatDate(this.end_time, 'HH:mm');
          let del_time = this.tableData[this.save_index]['start'] + '/' + this.tableData[this.save_index]['end'];
          // WebAPI呼び出し.
          await AWSAPI.updateFarmerFeedingTimes(this.farmer_id, add_time, del_time)
            .then((res) => {
              if (this.checkAnswer(res, false)) {
                this.viewMessage("餌やり時間を更新しました。", "success");
                this.dialogVisible = false;
              }
              this.get_current_user();
            });
        } else {
          this.dialogVisible = false;
          this.get_current_user();
        }
      }
    },
    click_del_feed_time(id) {
      let message = "餌やり時間『" + this.tableData[id]['start'] + "～" + this.tableData[id]['end'] + "』を削除しますか？";
      this.$confirm(message, "", {
        confirmButtonText: '削除',
        cancelButtonText: 'キャンセル',
        type: 'warning'
      }).then(() => {
        this.del_feed_time(id);
      }).catch(() => {
        return
      });
    },
    del_feed_time: async function (id) {
      this.loading = true;
      // WebAPI呼び出し.
      let del_time = this.tableData[id]['start'] + "/" + this.tableData[id]['end'];
      await AWSAPI.updateFarmerFeedingTimes(this.farmer_id, "", del_time)
        .then((res) => {
          if (this.checkAnswer(res, false)) {
            this.viewMessage("餌やり時間を削除しました。", "success");
          }
          this.get_current_user();
        });
    },
    restore_param() {
      // パラメータ復元
      this.isAdmin = this.$store.state.userAdmin;
    },
    // ===== 以降固定 ====
    get_current_user: async function () {
      // ログイン済みユーザー取得.
      this.loading = true;
      // WebAPI呼び出し.
      await AWSAPI.getUserSp3()
        .then((res) => {
          if (this.checkAnswer(res, true)) {
            this.userData = res['data']['data'][0];
          }
        });
    },
    get_id_token: async function () {
      try {
        const currentUser = await getCurrentUser();
        this.idToken = currentUser.idToken.jwtToken;
      } catch (e) {
        this.alertMessage("通知", ConstParam.relogin_message);
        this.$router.push('/login')
      }
    },
    viewMessage(message, status) {
      if (message === '') { return }
      if (status !== "error") {
        ElMessage({
          message: message,
          type: status
        });
      } else {
        ElMessage.error(message);
      }
    },
    checkAnswer(answer, autoLogout) {
      let message = "";
      try {
        const statusCode = answer.status;
        if (statusCode == 200) {
          // 正常応答
          if ("authToken" in answer) {
            this.idToken = answer.authToken;
            this.$cookies.set('Authorization', this.idToken);
          }
          return true;
        } else if (statusCode == 403) {
          // 共通鍵更新
          this.getCommonKey(this.publicKey_base64);
          return false;
        } else if (statusCode == 400 && answer.message.name === 'AxiosError') {
          // ユーザー削除のためログオフ
          this.loading = false;
          if (
            "response" in answer.message &&
            "data" in answer.message.response &&
            "message" in answer.message.response.data &&
            answer.message.response.data.message === "User Not Found"
          ) {
            message = ConstParam.user_error_message;
          } else {
            if (
              "response" in answer.message &&
              "data" in answer.message.response &&
              "message" in answer.message.response.data
            ) {
              this.viewMessage(answer.message.response.data.message, "error");
            }
            return false;
          }
        } else if ((statusCode == 400 && 'message' in answer && answer.message.message === 'need login') ||
          (statusCode == 400 && 'message' in answer && answer.message.message === 'Refresh Token has expired') ||
          (statusCode == 400 && answer.message.message === "Network Error") || autoLogout) {
          // Token期限切れのため再ログイン
          this.loading = false;
          message = ConstParam.relogin_message;
        } else {
          // レスポンスのエラーメッセージの表示
          if (
            "response" in answer.message &&
            "data" in answer.message.response &&
            "message" in answer.message.response.data
          ) {
            this.viewMessage(answer.message.response.data.message, "error");
          }
          return false;
        }
      } catch (e) {
        if (autoLogout) {
          // 自動ログアウト指定
          message = ConstParam.unknown_error_message
        } else {
          return false;
        }
      }
      if (!this.logOut) {
        // 多重処理防止のため
        this.logOut = true
        // ログオフ理由メッセージ通知
        if (this.message !== "") {
          this.alertMessage("通知", message);
        }
        this.click_user_signout();
      }
      return false;
    },
    alertMessage(title, message) {
      this.$alert(message, title, {
        confirmButtonText: 'OK'
      }).catch(() => {
        return
      });
    },
    click_user_signout: async function () {
      try {
        const currentUser = await getCurrentUser();
        if (currentUser) {
          await signout();
        }
      } catch (e) {
        console.log("log out.");
      }
      this.$router.push('/login')
    },
    getAuthLevel(userData) {
      let ret = 0
      if ('user_type' in userData && userData.user_type) {
        ret = userData.user_type
      }
      return ret
    },
    getIsAdmin(authLevel) {
      let ret = true
      if (authLevel != 0) {
        ret = false
      }
      return ret
    }
    // ==================
  },
  watch: {
    // ===== 以降固定 ====
    userData: function () {
      if ('user_name' in this.userData) {
        this.viewUserName = this.userData['user_name'];
      }
      if ('farmer' in this.userData && 'farmer_name' in this.userData['farmer']) {
        this.viewFarmerName = this.userData['farmer']['farmer_name'];
      }
      if ('farmer' in this.userData && 'farmer_id' in this.userData['farmer']) {
        this.farmer_id = this.userData['farmer']['farmer_id'];
      }
      this.feeding_times = [];
      if ('farmer' in this.userData && 'feeding_times' in this.userData['farmer']) {
        this.feeding_times = this.userData['farmer']['feeding_times'];
      }
      let tempUserType = this.getAuthLevel(this.userData)
      this.isAdmin = this.getIsAdmin(tempUserType)
      this.userType = tempUserType
      // パラメータ保存(権限)
      this.$store.commit('setUserAdmin', this.isAdmin);
      // アラート抑止
      this.amnion = false;
      this.calf_leg = false;
      this.tail_up = false;
      this.move_length = false;
      this.kicking = false;
      this.preyon = false;
      this.posture = false;
      if ("alert_notification" in this.userData && this.userData['alert_notification']) {
        this.amnion = (this.userData['alert_notification']['amnion'] ? 'ON' : 'OFF');
        this.calf_leg = (this.userData['alert_notification']['calf_leg'] ? 'ON' : 'OFF');
        this.tail_up = (this.userData['alert_notification']['tail_up'] ? 'ON' : 'OFF');
        this.move_length = (this.userData['alert_notification']['move_length'] ? 'ON' : 'OFF');
        this.kicking = (this.userData['alert_notification']['kicking'] ? 'ON' : 'OFF');
        this.preyon = (this.userData['alert_notification']['amount_of_prey'] ? 'ON' : 'OFF');
        this.posture = (this.userData['alert_notification']['posture_change'] ? 'ON' : 'OFF');
      }
      this.amnion_time = 5;
      this.calf_leg_time = 5;
      this.tail_up_time = 5;
      this.move_length_time = 5;
      this.kicking_time = 5;
      this.preyon_time = 5;
      this.posture_time = 5;
      if ("alert_supression_time" in this.userData && this.userData['alert_supression_time']) {
        this.amnion_time = this.userData['alert_supression_time']['amnion'];
        this.calf_leg_time = this.userData['alert_supression_time']['calf_leg'];
        this.tail_up_time = this.userData['alert_supression_time']['tail_up'];
        this.move_length_time = this.userData['alert_supression_time']['move_length'];
        this.kicking_time = this.userData['alert_supression_time']['kicking'];
        this.preyon_time = this.userData['alert_supression_time']['amount_of_prey'];
        this.posture_time = this.userData['alert_supression_time']['posture_change'];
      }
      // 餌やり時間
      let tempTable = [];
      for (let idx = 0; idx < this.feeding_times.length; idx++) {
        let tempParam = this.feeding_times[idx].split('/');
        let tempData = {
          start: tempParam[0],
          end: tempParam[1],
          feed_time: tempParam[0] + "～" + tempParam[1]
        }
        tempTable.push(tempData);
      }
      this.tableData = tempTable;
      // 種雄牛
      if ("bulls" in this.userData['farmer']) {
        this.bulls = this.userData['farmer']['bulls'];
      }
      // 受精卵
      if ("eggs" in this.userData['farmer']) {
        this.eggs = this.userData['farmer']['eggs'];
      }
      this.loading = false;
    }
    // ==================
  }
}
</script>

<style scoped>
div,
span {
  color: #383838;
}
</style>